import React from 'react';
import { Alert } from 'react-bootstrap';
require(`../assets/${process.env.PAGE}/css/custom-alert.css`);

	function CustomAlert(props) {
		return (
			<Alert bsStyle={props.bsStyle}>
				{typeof(props.title) !== 'undefined' && <strong>{props.title} </strong> }
				{typeof(props.message) !== 'undefined' && props.message }
				{typeof(props.description) !== 'undefined' && <p>{props.description} </p> }
			</Alert>);
	};
export default CustomAlert;



/** WEBPACK FOOTER **
 ** ./src/components/CustomAlert.js
 **/